import * as React from "react";
import { useLocation, useNavigate } from "react-router";
import { Card } from "@mantine/core";
import { ColorScheme } from "../../styles/scheme";
import LoginForm from "./LoginForm";
import BasketballBackground from "../common/BasketballBackground";

const background = {
  width: "100%",
  height: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "relative" as const,
};

function LoginPage() {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Simple dark mode detection using CSS media query
  const [isDarkMode, setIsDarkMode] = React.useState(
    window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
  );

  React.useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handler = (e: MediaQueryListEvent) => setIsDarkMode(e.matches);
    
    mediaQuery.addEventListener('change', handler);
    return () => mediaQuery.removeEventListener('change', handler);
  }, []);

  return (
    <div style={background} className="login-page-background">
      {/* Background SVG */}
      <BasketballBackground 
        isDarkMode={isDarkMode}
        style={{ 
          position: "absolute", 
          top: 0, 
          left: 0, 
          width: "100%", 
          height: "100%", 
          zIndex: -1 
        }}
      />
      
      {/* Login Card */}
      <Card 
        className="login-card"
        style={{ 
          padding: "40px 35px",
          backgroundColor: isDarkMode 
            ? "rgba(30, 35, 45, 0.8)" 
            : "rgba(255, 255, 255, 0.85)",
          backdropFilter: "blur(20px)",
          boxShadow: isDarkMode
            ? "0 20px 60px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.1)"
            : "0 20px 60px rgba(0, 50, 73, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.8)",
          border: isDarkMode
            ? "1px solid rgba(255, 255, 255, 0.08)"
            : "1px solid rgba(255, 255, 255, 0.3)",
          borderRadius: "20px",
          position: "relative",
          zIndex: 1,
          width: "400px",
          maxWidth: "90vw"
        }}
      >
        <h2 style={{ textAlign: "center" }} className="logo">
          Stadium Supervisor
        </h2>
        <hr className="col-xs-12" />
        <LoginForm
          style={{ width: "100%" }}
          navigate={navigate}
          redirectOnLogin={location?.state?.previousLocation}
        />
      </Card>
    </div>
  );
}

export default LoginPage;
